import { createSelector } from 'reselect';
import { TState } from '~/src/store';
import { EContactStatuses, IClientContacts, IContact } from '~/src/store/reducers/auth';

export const selectClientContacts = (state: TState): IClientContacts | null => {
    return state.auth.clientContacts || null;
};

export const selectClientContactsEmail = createSelector(
    selectClientContacts,
    (items) => {
        const emails = items?.email;
            return emails ? emails : [];
    }
);

export const selectClientContactsEmailConfirmed = createSelector(
    selectClientContacts,
    (items) => {
        let result: IContact[] = [];
        const emails = items?.email;
        if (emails) {
            result = emails.reduce((acc, val) => {
                    if (val.status === EContactStatuses.confirmed) {
                        acc.push(val);
                    }
                    return acc;
                }, <IContact[]>[]);
        }
        return result;
    }
);

export const selectClientContactsPhone = createSelector(
    selectClientContacts,
    (items) => {
        const emails = items?.email;
        return emails ? emails : [];
    }
);


